import React, { Fragment } from 'react';
import { ThreeCircles } from 'react-loader-spinner';
const Loader = () => {
  return (
    <Fragment>
      <ThreeCircles
        height="100"
        width="100"
        color="#E4A101"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="three-circles-rotating"
        outerCircleColor=""
        innerCircleColor=""
        middleCircleColor=""
      />
    </Fragment>
  );
};

export default Loader;
